import Box from '@mui/material/Box';
import useNRQuery from '../../../graphql/useNRQuery';
import { GET_LICENSE } from '../../../graphql/queries/license';
import NRLicenseDetails from './NRLicenseIssueDetails';
import CircularProgress from '@mui/material/CircularProgress';
import * as React from 'react';
import { useTheme } from '@mui/styles';
import Stack from '@mui/material/Stack';
import NRMetricCard from '../../NRMetricCard/NRMetricCard';
import NRLicenseIssuesIconX from '../../../NRIcons/NRLicenseIssuesIconX';
import { useContext, useEffect, useState } from 'react';
import { getSeverityColor } from '../../../utils/palette.utils';
import NRDrawerTile from './NRDrawerTile';
import { CONSTANTS } from '../../../constants/constants';
import { StringParam, useQueryParam } from 'use-query-params';
import { FiltersContext } from '../../../pages/NRReportTabs/NRReportFilterContextWrapper';
import { ArrayObjParam, encodeParam } from '../../../services/params.utils';
import { removeTabAndSubTabFromFilePath } from '../../../services/urlInterceptor.utils';
import { useLocation, useNavigate } from 'react-router-dom';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
const { EQUAL, CONTAINS } = CONSTANTS.FILTER_OPERATIONS;

function NRLicenseDrawerContainer({ spdxId }) {
  const theme = useTheme();
  const [, setCurrentTabParam] = useQueryParam('tab', StringParam);
  const { setOpenDrawer } = useContext(FiltersContext);
  const [, setColumnFilter] = useQueryParam('licenseIssuesColumnFilter', ArrayObjParam);
  const [, setSBOMColumnFilter] = useQueryParam('componentColumnFilter', ArrayObjParam);
  const [severityColor, setSeverityColor] = useState();
  const [redirectToParams, setRedirectToParams] = useState();
  const navigate = useNavigate();
  const location = useLocation();
  const [license, isLoading, _, tot, called] = useNRQuery({
    query: GET_LICENSE,
    options: {
      context: { version: 'v3' },
      fetchPolicy: 'no-cache',
      variables: {
        args: {
          spdxId: spdxId || 'test'
        }
      }
    },
    qlObjKey: 'license',
    transformData: data => {
      if (data) {
        setSeverityColor(getSeverityColor('medium' /*data.severity*/, theme));
      }
      return data;
    }
  });

  const handleTotalIssuesClick = () => {
    let extraParams = new URLSearchParams();
    extraParams.append(
      'licenseIssuesColumnFilter',
      encodeParam([
        {
          fieldName: 'LICENSE',
          value: spdxId || 'test',
          operation: EQUAL.toUpperCase()
        }
      ])
    );
    setRedirectToParams({ extraParams, tab: CONSTANTS.REPORT.TABS.LICENSE_ISSUES });
    setOpenDrawer(false);
  };

  useEffect(() => {
    !!redirectToParams &&
      !!redirectToParams?.extraParams &&
      navigate(`${removeTabAndSubTabFromFilePath(location)}/${redirectToParams.tab}?${redirectToParams.extraParams.toString()}`);
  }, [redirectToParams]);

  const handleTotalComponentsClick = () => {
    let extraParams = new URLSearchParams();
    extraParams.append(
      'componentColumnFilter',
      encodeParam([
        {
          fieldName: 'NAME',
          value: 'busybox',
          operation: CONTAINS.toUpperCase()
        },
        {
          fieldName: 'VERSION',
          value: '1.31.1',
          operation: CONTAINS.toUpperCase()
        }
      ])
    );
    setRedirectToParams({ extraParams, tab: CONSTANTS.REPORT.TABS.SBOM });
    setOpenDrawer(false);
  };

  return (
    <Box
      id={'license-details-main-container'}
      sx={{ height: '100%', maxHeight: 'calc(100vh - 176px)', overflowY: 'auto', padding: theme.spacing(3, 3, 6) }}
    >
      {!isLoading && !!called && !!license && (
        <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} gap={theme.spacing(2)}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <NRMetricCard
              maxWidth={'48%'}
              metric={'License'}
              result={license.licenseName}
              icon={<NRLicenseIssuesIconX height={theme.spacing(4)} width={theme.spacing(4)} color={theme.palette.text.iconInfo} />}
              caption={`${license?.licenseType || 'This should be the type'}`}
            />
            <NRMetricCard
              metric={'Issues'}
              result={license.issuesCount || '3 for testing'}
              icon={<WarningAmberOutlinedIcon sx={{ width: theme.spacing(3), height: theme.spacing(3), color: theme.palette.warning.main }} />}
              caption={'1 Blocker, 1 Critical, 1 High, 1 Medium, 1 Low'}
            />
          </Stack>

          <NRLicenseDetails license={license} />
          <NRDrawerTile total={5} title={'Issues'} handleTotalClick={handleTotalIssuesClick} />
          <NRDrawerTile total={50} title={'Associated Components'} handleTotalClick={handleTotalComponentsClick} />
        </Box>
      )}
      {!!isLoading && (
        <Box display="flex" alignItems={'center'} justifyContent={'center'} height={'100%'}>
          <CircularProgress sx={{ marginLeft: '8px' }} color={'primary'} size={20} />
        </Box>
      )}
    </Box>
  );
}

export default NRLicenseDrawerContainer;
